// extracted by mini-css-extract-plugin
module.exports = {"Trivia":"Trivia_Trivia__1ggvG","artImg":"Trivia_artImg__2zNLY"};